<div
  class="wrapper wrapper-content animated fadeInRight course-assignment-page"
>
  @if (loading() && !players().length) {
  <div class="loading-placeholder text-center">
    <i class="fa fa-refresh fa-spin"></i>
    <span>Loading course assignments…</span>
  </div>
  } @if (error()) {
  <div class="row">
    <div class="col-lg-12">
      <div class="alert alert-danger">
        <i class="fa fa-exclamation-triangle"></i>
        {{ error() }}
        <button
          class="btn btn-link btn-xs pull-right"
          type="button"
          (click)="refreshAll()"
        >
          <i class="fa fa-refresh"></i> Retry
        </button>
      </div>
    </div>
  </div>
  } @if (validationMessages().length) {
  <div class="row">
    <div class="col-lg-12">
      <div class="alert alert-warning alert-dismissible">
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="closeValidationMessages()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="alert-heading">
          <i class="fa fa-info-circle"></i> Resolve course assignment issues
        </h4>
        <ul class="list-unstyled m-t-sm m-b-none">
          @for (message of validationMessages(); track message) {
          <li><i class="fa fa-warning text-warning"></i> {{ message }}</li>
          }
        </ul>
      </div>
    </div>
  </div>
  }

  <div class="row m-b-xs">
    <div class="col-lg-8">
      <div class="page-heading">
        <div class="meta">
          <span>
            <i class="fa fa-flag"></i>
            {{ tournament()?.name ?? "Select a tournament" }}
          </span>
          @if (round()) {
          <span>
            <i class="fa fa-calendar"></i>
            Round {{ round()?.number ?? "?" }}
          </span>
          }
          <span class="text-muted">
            <i class="fa fa-users"></i>
            {{ totalPlayers() }} players in field
          </span>
        </div>
      </div>
    </div>
    <div class="col-lg-4 text-right">
      <div class="header-actions">
        <button
          class="btn btn-link"
          type="button"
          (click)="refreshPlayers()"
          [disabled]="loading() || mutating()"
        >
          <i class="fa fa-refresh"></i> Refresh Players
        </button>
        <button
          class="btn btn-link"
          type="button"
          (click)="refreshAll()"
          [disabled]="loading() || mutating()"
        >
          <i class="fa fa-database"></i> Refresh All
        </button>
      </div>
    </div>
  </div>

  <div class="row m-b-md">
    <div class="col-lg-12">
      <div class="assignment-summary">
        <div>
          <span class="summary-label">Assigned</span>
          <strong>{{ assignedCount() }}</strong>
        </div>
        <div>
          <span class="summary-label">Unassigned</span>
          <strong>{{ unassignedCount() }}</strong>
        </div>
        <div class="progress-wrapper">
          <span class="summary-label">Progress</span>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              [attr.aria-valuenow]="assignmentProgress()"
              aria-valuemin="0"
              aria-valuemax="100"
              [style.width.%]="assignmentProgress()"
            >
              {{ assignmentProgress() }}%
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row m-b-md">
    <div class="col-lg-12">
      <div class="ibox quick-actions">
        <div class="ibox-title">
          <h5><i class="fa fa-magic"></i> Bulk assignment tools</h5>
          <div class="ibox-tools">
            <span
              class="label label-default"
              [class.label-warning]="mutating()"
              >{{ mutating() ? "Processing…" : "Ready" }}</span
            >
          </div>
        </div>
        <div class="ibox-content">
          <div class="bulk-actions">
            <button
              class="btn btn-success"
              type="button"
              (click)="bulkAssign('even')"
              [disabled]="mutating() || loading()"
            >
              <i class="fa fa-balance-scale"></i> Auto-Assign Evenly
            </button>
            <button
              class="btn btn-info"
              type="button"
              (click)="bulkAssign('rank-alternate')"
              [disabled]="mutating() || loading()"
            >
              <i class="fa fa-sort-numeric-asc"></i> Assign by Rank (Alternate)
            </button>
            <button
              class="btn btn-warning"
              type="button"
              (click)="bulkAssign('random')"
              [disabled]="mutating() || loading()"
            >
              <i class="fa fa-random"></i> Assign Randomly
            </button>
            <button
              class="btn btn-white"
              type="button"
              (click)="bulkAssign('copy-previous')"
              [disabled]="mutating() || loading() || !canCopyPreviousRound()"
            >
              <i class="fa fa-copy"></i> Copy Previous Round
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="course-assignment-container" [class.is-loading]="loading()">
    <div class="players-panel">
      <div
        class="panel-header clickable-row"
        (click)="togglePlayersPanel()"
      >
        <div>
          <h4>Tournament Players</h4>
          <small
            >{{ filteredPlayers().length }} shown &bull;
            {{ selectedCount() }} selected</small
          >
        </div>
        <div class="panel-actions-wrapper">
          <div class="panel-actions" (click)="$event.stopPropagation()">
            <label class="select-all">
              <input
                type="checkbox"
                [checked]="allFilteredSelected()"
                [disabled]="!filteredPlayers().length"
                (change)="$event.stopPropagation(); toggleSelectAllFiltered()"
              />
              <span>Select shown</span>
            </label>
          </div>
          <i
            class="fa collapse-icon"
            [ngClass]="playersCollapsed() ? 'fa-chevron-down' : 'fa-chevron-up'"
          ></i>
        </div>
      </div>

      @if (!playersCollapsed()) {
      <div class="filters">
        <div class="filter-group">
          <button
            type="button"
            class="btn btn-xs"
            [class.btn-primary]="statusFilter() === 'all'"
            [class.btn-white]="statusFilter() !== 'all'"
            (click)="setStatusFilter('all')"
          >
            All <span class="badge badge-light">{{ totalPlayers() }}</span>
          </button>
          <button
            type="button"
            class="btn btn-xs"
            [class.btn-primary]="statusFilter() === 'assigned'"
            [class.btn-white]="statusFilter() !== 'assigned'"
            (click)="setStatusFilter('assigned')"
          >
            Assigned
            <span class="badge badge-light">{{ assignedCount() }}</span>
          </button>
          <button
            type="button"
            class="btn btn-xs"
            [class.btn-primary]="statusFilter() === 'unassigned'"
            [class.btn-white]="statusFilter() !== 'unassigned'"
            (click)="setStatusFilter('unassigned')"
          >
            Unassigned
            <span class="badge badge-light">{{ unassignedCount() }}</span>
          </button>
        </div>
        <div class="search-box">
          <i class="fa fa-search"></i>
          <input
            type="text"
            class="form-control"
            placeholder="Search players by name"
            [value]="searchTerm()"
            (input)="updateSearchTerm($any($event.target).value)"
          />
        </div>
      </div>

      <div class="player-list">
        @if (filteredPlayers().length === 0) {
        <div class="empty-state">
          <i class="fa fa-users"></i>
          <p>No players match the current filters.</p>
          @if (statusFilter() !== 'all' || searchTerm()) {
          <button
            class="btn btn-link btn-sm"
            type="button"
            (click)="setStatusFilter('all'); updateSearchTerm('')"
          >
            Reset filters
          </button>
          }
        </div>
        } @else { @for (player of filteredPlayers(); track
        player.businessEntityId) {
        <div
          class="player-item"
          [class.selected]="playerIsSelected(player.businessEntityId)"
          (click)="togglePlayerSelection(player.businessEntityId)"
        >
          <input
            type="checkbox"
            [checked]="playerIsSelected(player.businessEntityId)"
            (click)="$event.stopPropagation()"
            (change)="togglePlayerSelection(player.businessEntityId)"
          />
          <span
            class="player-rank"
            [class.no-rank]="player.rank === null || player.rank === undefined"
          >
            {{ player.rank ?? "—" }}
          </span>
          <div class="player-meta">
            <div class="player-name">{{ player.fullName }}</div>
            <div class="player-detail">
              @if (player.currentAssignment) {
              <span class="badge badge-success">
                <i class="fa fa-map-marker"></i>
                {{ player.currentAssignment.courseName }}
              </span>
              } @else {
              <span class="badge badge-warning">
                <i class="fa fa-exclamation-circle"></i> Unassigned
              </span>
              } @if (!player.currentAssignment && player.previousAssignment) {
              <span class="badge badge-info previous-assignment">
                <i class="fa fa-history"></i> Prev:
                {{ player.previousAssignment.courseName }}
              </span>
              }
            </div>
          </div>
        </div>
        } }
      </div>

      <div class="selection-toolbar">
        <div class="left-actions">
          <button
            class="btn btn-link btn-sm"
            type="button"
            (click)="selectUnassigned()"
            [disabled]="!unassignedCount()"
          >
            <i class="fa fa-filter"></i> Select all unassigned
          </button>
          <button
            class="btn btn-link btn-sm"
            type="button"
            (click)="clearSelection()"
            [disabled]="!hasSelection()"
          >
            <i class="fa fa-eraser"></i> Clear selection
          </button>
        </div>
        <div
          class="assign-actions"
          [class.disabled]="!hasSelection() || mutating()"
        >
          <label>Assign selected to:</label>
          <div class="btn-group">
            @for (course of courses(); track course.roundTournamentCourseId) {
            <button
              type="button"
              class="btn btn-white"
              (click)="assignSelectedToCourse(course)"
              [disabled]="!hasSelection() || mutating()"
            >
              <i class="fa fa-arrow-right"></i> {{ course.courseName }}
            </button>
            }
          </div>
        </div>
      </div>
      }
    </div>

    <div class="assignment-panel">
      <div
        class="panel-header clickable-row"
        (click)="toggleCoursesPanel()"
      >
        <div>
          <h4>Course Buckets</h4>
          <small>Monitor player distribution per course</small>
        </div>
        <i
          class="fa collapse-icon"
          [ngClass]="coursesCollapsed() ? 'fa-chevron-down' : 'fa-chevron-up'"
        ></i>
      </div>

      @if (!coursesCollapsed()) {
      <div class="course-list">
        @if (courses().length === 0) {
        <div class="empty-state">
          <i class="fa fa-flag-o"></i>
          <p>No courses configured for this round.</p>
        </div>
        } @else { @for (course of courses(); track
        course.roundTournamentCourseId) {
        <div
          class="course-bucket"
          [ngClass]="courseHeaderClass(course.roundTournamentCourseId)"
        >
          <div class="course-bucket-header">
            <div>
              <h4>{{ course.courseName }}</h4>
              <span
                class="badge-count"
                [ngClass]="{
                  'badge-complete': courseSummary(
                    course.roundTournamentCourseId
                  )?.isComplete,
                  'badge-empty':
                    (courseSummary(course.roundTournamentCourseId)
                      ?.assignedPlayerCount ??
                      0) ===
                    0
                }"
              >
                {{
                  courseSummary(course.roundTournamentCourseId)
                    ?.assignedPlayerCount ?? 0
                }}
              </span>
            </div>
            <div class="course-meta">
              <span class="percentage">{{
                formatPercentage(
                  courseSummary(course.roundTournamentCourseId)
                    ?.percentageAssigned
                )
              }}</span>
              <button
                class="btn btn-link btn-xs"
                type="button"
                (click)="assignSelectedToCourse(course)"
                [disabled]="!hasSelection() || mutating()"
              >
                <i class="fa fa-arrow-right"></i> Assign selected
              </button>
            </div>
          </div>
          <div class="course-bucket-content">
            @if (playersAssignedToCourse(course.roundTournamentCourseId).length
            === 0) {
            <div class="empty-bucket">
              <i class="fa fa-inbox"></i>
              <p>No players assigned yet.</p>
            </div>
            } @else { @for (player of
            playersAssignedToCourse(course.roundTournamentCourseId); track
            player.businessEntityId) {
            <div class="assigned-player">
              <div>
                <strong>{{ player.rank ?? "—" }}.</strong> {{ player.fullName }}
              </div>
              <button
                type="button"
                class="btn btn-link btn-xs text-danger"
                (click)="removeAssignment(player)"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
            } }
          </div>
        </div>
        } }
      </div>
      }
    </div>
  </div>

  @if (summary(); as summaryValue) {
  <div class="status-bar">
    <div class="status-summary">
      <div class="status-item">
        <div
          class="progress-circle"
          [style.background-image]="
            'conic-gradient(#1ab394 ' +
            assignmentProgress() +
            '%, #3f4f5f ' +
            assignmentProgress() +
            '% 100%)'
          "
        >
          <div class="progress-circle-inner">{{ assignmentProgress() }}%</div>
        </div>
        <div>
          <strong>{{ assignedCount() }} / {{ totalPlayers() }}</strong
          ><br />
          <small>Players Assigned</small>
        </div>
      </div>
      @for (courseSummary of summaryValue.courses; track
      courseSummary.roundTournamentCourseId) {
      <div class="status-item">
        <i
          class="fa"
          [ngClass]="{
            'fa-check-circle text-success': courseSummary.isComplete,
            'fa-exclamation-circle text-warning':
              courseSummary.assignedPlayerCount === 0,
            'fa-info-circle text-info':
              !courseSummary.isComplete && courseSummary.assignedPlayerCount > 0
          }"
        ></i>
        <div>
          <strong>{{ courseSummary.courseName }}</strong
          ><br />
          <small
            >{{ courseSummary.assignedPlayerCount }} players ({{
              courseSummary.percentageAssigned | number : "1.0-0"
            }}%)</small
          >
        </div>
      </div>
      }
    </div>
    <div class="status-actions">
      <button
        class="btn btn-primary btn-lg"
        type="button"
        (click)="proceedToPairings()"
        [disabled]="!canProceedToPairings() || mutating()"
      >
        <i class="fa fa-save"></i> Save &amp; Continue to Pairings
      </button>
    </div>
  </div>
  }
</div>
